import styled from 'styled-components';

export const DocumentIconWrapper = styled.div<{ selected?: boolean }>`
  margin: 0 15px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 3px;
  border: 2px solid ${({ theme, selected }) => (selected ? theme.color.clear_blue : 'transparent')};
`;
